module.exports = __webpack_public_path__ + "img/314.122ad80f.gif";